export default __webpack_public_path__ + "static/media/portada_KatiaKolovea_ENG.6aaf13ee.jpg";